import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : u.onboarded ? "/app" : "/onboarding");
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-8" data-testid="login-logo"><Logo /></Link>
        <div className="glass rounded-3xl p-8">
          <h1 className="font-display text-3xl text-navy">Welcome back.</h1>
          <p className="text-sm text-navy/60 mt-1">Kind hearts always find their way home.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-xs font-medium text-navy/70">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full px-4 py-3 rounded-xl bg-white border border-navy/10" placeholder="you@licencetolove.com" />
            </div>
            <div>
              <label className="text-xs font-medium text-navy/70">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full px-4 py-3 rounded-xl bg-white border border-navy/10" placeholder="••••••••" />
            </div>
            {err && <div className="text-sm text-rose-600" data-testid="login-error">{err}</div>}
            <button data-testid="login-submit" type="submit" disabled={busy}
              className="btn-pill w-full bg-rose text-white hover:bg-rose-600 hover:scale-[1.01] disabled:opacity-60">
              {busy ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <div className="text-sm text-navy/60 mt-6 text-center">
            New here?{" "}
            <Link to="/register" data-testid="login-goto-register" className="text-rose hover:underline">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
